<template>
  <v-text-field
    v-bind="$props"
    :value="modelValue"
    @input="(newValue) => (modelValue = newValue)"
  >
    <v-icon
      v-if="clientFileId"
      slot="prepend"
      :color="isVerified ? 'green' : 'default'"
      @click="getPanVarificationStatus()"
    >
      {{ isVerified ? "mdi-check-circle" : "mdi-refresh" }}
    </v-icon>
    <v-icon v-if="panVerified" slot="prepend" :color="'green'">
      {{ "mdi-check-circle" }}
    </v-icon>
  </v-text-field>
</template>
<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import { VTextField } from "vuetify/lib/components";
import * as Data from "@/../src-gen/data";
// import * as ServerData from '@/../src-gen/server-data';
import * as Action from "@/../src-gen/action";
import FSnackbar from "@/fsnackbar";


@Component({
  components: {
    VTextField,
  },
})
export default class FPANTextField extends VTextField {
  @Prop()
  value: string;

  @Prop({
    default: false,
  })
  panVerified: boolean;

  @Prop()
  mask: string;

  @Prop()
  unmask: string;

  @Prop({ default: null })
  clientFileId: string;

  isVerified: boolean = false;

  /**
   * ***************DO NOT DELETE*************************
   * maxlength is not available in a VTextField props.
   * thats why we have added as a prop.
   * but it is passed to the built in html props.
   * ****************************************************
   */
  @Prop()
  maxlength: string;

  mounted() {
    this.getPanVarificationStatus();
  }

  getPanVarificationStatus() {
    if (this.clientFileId && !this.isVerified) {
      Action.ClientFile.GetPanVerificationStatus.execute1(
        this.clientFileId,
        (output) => {
          this.isVerified = output.panVerificationStatus;
          if (!output.panVerificationStatus) {
            FSnackbar.error(output.message);
          }
        }
      );
    }
  }

  get modelValue() {
    return this.mask ? this.getMaskedValued(this.value) : this.value;
  }

  set modelValue(newModelValue: string) {
    const value = this.mask
      ? this.getUnMaskedValue(newModelValue)
      : newModelValue;
    this.$emit("input", value);
  }

  getMaskedValued(value: string): string {
    if (!value) {
      return "";
    }
    return this.formatDefault(value, this.mask);
  }

  getUnMaskedValue(value: string) {
    if (!value) {
      return "";
    }
    return this.formatDefault(value, this.unmask);
  }

  formatDefault(value: string, mask: string) {
    value = this.clearValue(value);
    let result = "";
    let count = 0;
    if (value) {
      let arrayValue = value.toString().split("");
      let arrayMask = mask.toString().split("");
      for (var i = 0; i < arrayMask.length; i++) {
        if (i < arrayValue.length + count) {
          if (arrayMask[i] === "#") {
            result = result + arrayValue[i - count];
          } else {
            result = result + arrayMask[i];
            count++;
          }
        }
      }
    }
    return result;
  }

  clearValue(value: string) {
    let result = "";
    if (value) {
      let arrayValue = value.toString().split("");
      for (var i = 0; i < arrayValue.length; i++) {
        if (this.isValid(arrayValue[i])) {
          result = result + arrayValue[i];
        }
      }
    }
    return result;
  }

  isValid(value: string) {
    return this.isInteger(value);
  }

  isInteger(value: string) {
    let result = false;
    if (Number.isInteger(parseInt(value))) {
      result = true;
    }
    return result;
  }

  selectModel(modelData: any, modelSelectorKey: string | undefined) {
    if (!modelSelectorKey) {
      return modelData;
    } else {
      const arr = modelSelectorKey.split(".");
      let ret = modelData;
      arr.forEach((elem) => {
        ret = ret ? ret[elem] : ret;
      });

      return ret;
    }
  }

  updateModel(
    modelData: any,
    newValue: any,
    modelSelectorKey: string | undefined
  ) {
    if (!modelSelectorKey) {
      modelData = newValue;
    } else {
      const arr = modelSelectorKey.split(".");
      if (arr.length == 1) {
        modelData[modelSelectorKey] = newValue;
      } else {
        const lastDataSelector = arr[arr.length - 1];
        const childDataSelector = arr.slice(0, arr.length - 1).join(".");
        const childModelData = this.selectModel(modelData, childDataSelector);
        childModelData[lastDataSelector] = newValue;
      }
    }
  }
  // MODEL VALUE - END
}
</script>
<style>
.v-input--is-readonly input,
.v-input--is-readonly .v-select__selection,
.v-input--is-readonly textarea {
  color: #000 !important;
  cursor: default !important;
}
.v-text-field input {
  font-size: 14px;
  min-height: 10px;
}

.v-text-field input::placeholder {
  font-size: 14px;
}
</style>
